import React, { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL;

const App = () => {
  const [getExtensionStatus, setExtensionStatus] = useState([]);
  const [getReviewsStatus, setReviewsStatus] = useState([]);
  const [downloadVsixStatus, setDownloadVsixStatus] = useState([]);
  const [tooltip, setTooltip] = useState({ visible: false, text: "", x: 0, y: 0 });

  useEffect(() => {
    const fetchData = async (url, setter) => {
      try {
        const response = await fetch(`${API_URL}${url}`);
        const data = await response.json();
        setter(data);
      } catch (error) {
        console.error(`Error fetching ${url}:`, error);
      }
    };

    fetchData("/health/get_extensions", setExtensionStatus);
    fetchData("/health/get_reviews", setReviewsStatus);
    fetchData("/health/download_vsix", setDownloadVsixStatus);
  }, []);

  const showTooltip = (event, text) => {
    const { clientX, clientY } = event;
    setTooltip({ visible: true, text, x: clientX + 10, y: clientY + 10 });
  };

  const hideTooltip = () => {
    setTooltip({ visible: false, text: "", x: 0, y: 0 });
  };

  const renderStatusBars = (statusList, title) => (
    <div style={{ marginBottom: "20px" }}>
      <div
        style={{
          marginBottom: "10px",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <h3
          style={{
            color: "purple",
            fontSize: "14px", // Smaller title
            marginRight: "15px", // Space between title and status bars
          }}
        >
          {title}
        </h3>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "5px",
          padding: "10px",
          borderRadius: "15px",
          backgroundColor: "#f3f3f3",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        {statusList.length > 0 ? (
          statusList.map((status, index) => (
            <div
              key={index}
              style={{
                width: "10px",
                height: "30px",
                backgroundColor: status.status_code === 200 ? "green" : "red",
                borderRadius: "2px",
              }}
              onMouseEnter={(e) =>
                showTooltip(
                  e,
                  `Timestamp: ${new Date(status.timestamp).toLocaleString()}`
                )
              }
              onMouseLeave={hideTooltip}
            />
          ))
        ) : (
          <p style={{ color: "gray" }}>Loading statuses...</p>
        )}
      </div>
    </div>
  );

  return (
    <div style={{ padding: "20px", position: "relative" }}>
      <h1 style={{ textAlign: "center", color: "purple" }}>Service Health</h1>
      {renderStatusBars(getExtensionStatus, "Get Extensions Status")}
      {renderStatusBars(getReviewsStatus, "Get Reviews Status")}
      {renderStatusBars(downloadVsixStatus, "Download VSIX Status")}

      {tooltip.visible && (
        <div
          style={{
            position: "absolute",
            top: `${tooltip.y}px`,
            left: `${tooltip.x}px`,
            backgroundColor: "black",
            color: "white",
            padding: "5px",
            borderRadius: "5px",
            fontSize: "12px",
            pointerEvents: "none",
            whiteSpace: "nowrap",
          }}
        >
          {tooltip.text}
        </div>
      )}
    </div>
  );
};

export default App;
